import { useLayoutEffect, type MutableRefObject } from "react";

import type { TimelineViewTransform } from "@/lib/timeline/view/ViewTransform/transform";

interface LockedCameraLayoutInput {
  cameraLockEnabled: boolean;
  viewRef: MutableRefObject<TimelineViewTransform>;
  lastFitMsRef: MutableRefObject<number>;
  prevCameraLockRef: MutableRefObject<boolean>;
  panBreakRef: MutableRefObject<boolean>;
  setViewTransform: (view: TimelineViewTransform) => void;
}

/** Keep the current frame when the lock turns off. Auto zoom eases on its own. */
export function useLockedCameraLayout(input: LockedCameraLayoutInput): void {
  const {
    cameraLockEnabled,
    viewRef,
    lastFitMsRef,
    prevCameraLockRef,
    panBreakRef,
    setViewTransform,
  } = input;

  useLayoutEffect(() => {
    const justEnabled = cameraLockEnabled && !prevCameraLockRef.current;
    const justDisabled = !cameraLockEnabled && prevCameraLockRef.current;
    prevCameraLockRef.current = cameraLockEnabled;

    if (justDisabled) {
      panBreakRef.current = false;
      setViewTransform(viewRef.current);
      return;
    }
    if (justEnabled) {
      panBreakRef.current = false;
      lastFitMsRef.current = 0;
    }
  }, [
    cameraLockEnabled,
    lastFitMsRef,
    panBreakRef,
    prevCameraLockRef,
    setViewTransform,
    viewRef,
  ]);
}
